// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {ComponentProps, forwardRef} from 'react';
import cn from 'classnames';
import {Button as Basic_button} from '../../../../hola/pub/lib/button';
import styles from './button.module.less';

export type t_oculus_button_color = 'primary' | 'secondary' | 'tertiary'
    | 'destructive' | 'social' | 'transparent';
export type t_oculus_button_size = 'l' | 'm' | 's' | 'xs' | 'xxs';

export type t_oculus_button_props = ComponentProps<typeof Basic_button> & {
    color?: t_oculus_button_color;
    size?: t_oculus_button_size;
    icon_only?: boolean;
    inherit_width?: boolean;
};

export const Button = forwardRef<HTMLButtonElement, t_oculus_button_props>(
    (props, ref)=>{
        const {cls, color = 'primary', size = 'm', round = false, icon_only,
            no_jump = true, fit = true, ...rest} = props;
        const button_cls = cn(cls, styles.oculus_button, styles[color],
            styles[`size_${size}`], {
                [styles.icon_only]: icon_only,
            });
        return <Basic_button
          cls={button_cls} round={round} no_jump={no_jump} fit={fit}
          ref={ref} {...rest}
        />;
    }
);
